import type { AddToListsTarget } from "@/lib/add-to-lists-target";

export function resolveAlbumCardAddToListsTarget(
  target: AddToListsTarget | undefined,
  workId: string | undefined,
): AddToListsTarget | undefined {
  if (target) return target;
  if (!workId) return undefined;
  return { entityType: "work", workId };
}
